import { PermissionRoles } from './enums'

export const roles = {
  filterRoles: [PermissionRoles.VOLUMETRY_REGION_ADMIN]
}